export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.recruitCategories = payload;

  return newState;
};
